import { j } from "./jsx-runtime-3tyXYecC.mjs";
import { createContext as v, useState as y, useEffect as P } from "react";
const d = v({}), b = ({
  children: x,
  currencyCode: t,
  decimalCharacter: o,
  defaultCurrency: e,
  defaultDecimalChar: c,
  defaultThousandsSeparator: n,
  getCurrencyCollection: s,
  getCurrencyItems: a,
  normalizeZeros: l,
  padFractionalZeros: f,
  scale: p,
  thousandsSeparator: u
}) => {
  const [i, C] = y();
  return P(() => {
    var m;
    (m = a || s) == null || m().then((r) => C(r)).catch((r) => console.error("Unable to get currency collection.", r));
  }, [e, s, a]), /* @__PURE__ */ j.jsx(
    d.Provider,
    {
      value: {
        currencyCode: t ?? e,
        currencyItems: i,
        decimalCharacter: o ?? c,
        defaultCurrency: t ?? e,
        defaultCurrencyCollection: i,
        defaultDecimalChar: o ?? c,
        defaultThousandsSeparator: u ?? n,
        normalizeZeros: l,
        padFractionalZeros: f,
        scale: p,
        thousandsSeparator: u ?? n
      },
      children: x
    }
  );
};
export {
  d as C,
  b as a
};
//# sourceMappingURL=currency-picker-provider-CTRNrW3S.mjs.map
